import { Component, OnInit, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { WorkorderService } from 'src/app/services/workorder.service';
import { UtilityService } from 'src/app/services/utility.service';
import Swal from 'sweetalert2';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-viewdocs-dialog',
  templateUrl: './viewdocs-dialog.component.html',
  styleUrls: ['./viewdocs-dialog.component.scss']
})
export class ViewdocsDialogComponent implements OnInit, AfterViewInit {
  fileTypes: any = [];
  displayedColumns: string[] = ['ImageCode', 'Description', 'FileName', 'View', 'Delete'];
  files = new MatTableDataSource<any>([]);
  loadFile: boolean = true;
  officeId: string = '';
  @ViewChild(MatSort) sort!: MatSort;
  editingImageId: string | null = null;
  editedDescription: string = '';
  isCustomUiChange: string = '';
  workorderID: any = this.workorderService.currentWorkorderID;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private workorderService: WorkorderService,
    private userService: UserService
  ) { }

  ngOnInit(): void {
    this.officeId = this.data?.officeId;
    this.getDocuments();
    this.isCustomUiChange = this.userService.IsCustomUiChange;
    this.workorderService.getFileTypesForUpload(this.workorderID).subscribe((res) => {
      this.fileTypes = res;
    });

    // This triggers sorting initially
    //this.files.sort.sort({ id: this.sort.active, start: this.sort.direction, disableClear: true });
  }

  ngAfterViewInit(): void {
    this.files.sort = this.sort;
    this.sort.active = 'ImageCode'; // Column to sort by default
    this.sort.direction = 'asc'; // Sort order ('asc' for ascending, 'desc' for descending)
  }

  getDocuments(): void {
    this.loadFile = true;
    this.workorderService.getDocumentsForWorkorder(this.data.workOrderID, this.data.lineItemID)
      .subscribe((res) => {
        this.files.data = res;
        this.loadFile = false;
        
        this.files.sort = this.sort;
      });
  }

  // imageType(imageCode: string) {
  //   for (let file of this.fileTypes) {
  //     if (file.ImageCode == imageCode) {
  //       return file.ImageDescription;
  //     }
  //   }
  // }

  imageType(imageCode: string): string {
    return (
      this.fileTypes.find((file: any) => file.ImageCode == imageCode)?.ImageDescription || ''
    );
  }

  startEdit(file: any): void {
    this.editingImageId = file.ImageId;
    this.editedDescription = file.Description || '';
  }

  cancelEdit(): void {
    this.editingImageId = null;
    this.editedDescription = '';
  }

  updateDescription(file: any): void {
    if (!this.editedDescription?.trim()) {
      Swal.fire({
        icon: 'warning',
        text: 'Description is Required'
      });
      return;
    }
    const body = {
      ImageId: file.ImageId,
      Description: this.editedDescription
    };

    this.workorderService.updateDocumentDescription(
      body,
      this.officeId,
      this.workorderID
    )
      .subscribe({
        next: () => {
          file.Description =
            this.editedDescription;
          this.cancelEdit();
          Swal.fire({
            icon: 'success',
            text: 'Description updated successfully'
          });
        },
        error: () => {
          Swal.fire({
            icon: 'error',
            text: 'Failed to update description'
          });
        }
      });
  }

  openFile(file: any): void {
    this.workorderService.openImageFile(file);
  }

  deleteFile(file: any): void {
    Swal.fire({
      title: 'Delete?',
      text: "Are you sure you want to delete file?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Delete'
    }).then((result) => {
      if (result.value) {
        //this.spinner.show();
        let body = {
          "ImageId": file.ImageId
        }

        this.workorderService.deleteFile(body, this.workorderID).subscribe((res: any) => {
          if (!res.Action) {
            Swal.fire({
              text: "File deleted successfully!",
              icon: 'success',
              confirmButtonText: 'OK',
            }).then(() => {
              this.dialog.closeAll();
            })
          } else {
            Swal.fire({
              text: res.ErrorMessage,
              icon: 'error',
              confirmButtonText: 'OK',
            }).then(() => {
              this.dialog.closeAll();
            })
          }
        });
      }
    });
  }
}
